// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_components__CopyButton from "../../../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__CopyButton24 from "../../../../../../../packages/components/src/CopyButton24.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Formating from "../../../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersKogdView(Props) {
  let ogds = Props.ogds;
  let id = Props.id;
  const ogd = Belt__Belt_List.reduce(ogds, {
    code: "",
    parent: undefined,
    name: "",
    keywords: "",
    tin: "",
    contact_phone: undefined,
    effective_from: undefined,
    effective_until: undefined
  }, (function (acc, param) {
    try {
      return Stdlib__List.find((function (a) {
        return a.code === id;
      }), param[1]);
    }
    catch (exn){
      return acc;
    }
  }));
  const phone = ogd.contact_phone;
  const phone$1 = ogd.contact_phone;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: /* COUNTRY_KAZ */ 1,
          _1: /* Ru */ 1,
          _2: {
            TAG: /* Classifiers */ 8,
            _0: {
              TAG: /* Kogd */ 0,
              _0: /* List */ 0
            }
          }
        },
        className: "flex gap-2 items-center",
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6",
            src: StaticAsset.src("/static/icons/arrow-back-black-24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "На главную",
            className: "paragraph text-gray-medium"
          })
        ],
        scrollToTop: false
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h6", {
            children: ogd.name,
            className: "h6 text-black-landing"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_components__CopyButton24.make, {
              text: ogd.name
            }),
            className: "hidden lg:block opacity-0 group-hover:opacity-100"
          })
        ],
        className: "flex lg:px-2 py-1 hover:bg-gray-pale mt-10 items-end gap-2 group rounded-md w-fit"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Код",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: ogd.code,
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: ogd.code
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100"
                        })
                      ],
                      className: "flex hover:bg-gray-pale items-end gap-1 group rounded-md justify-between lg:justify-start lg:px-2 py-1 w-fit"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "БИН",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: ogd.tin,
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: ogd.tin
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100"
                        })
                      ],
                      className: "flex lg:px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md justify-between lg:justify-start w-fit"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Номер",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("p", {
                        children: phone !== undefined ? JsxRuntime.jsx("a", {
                            children: Formating.formatPhone(phone),
                            href: "tel:" + phone
                          }) : "-",
                        className: "paragraph text-black-landing"
                      }),
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                          text: phone$1 !== undefined ? phone$1 : "-"
                        }),
                        className: "lg:opacity-0 group-hover:opacity-100"
                      })
                    ],
                    className: "flex lg:px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md justify-between lg:justify-start"
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              })
            ],
            className: "lg:grid grid-cols-[auto_auto] gap-x-2 gap-y-1 items-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Банк",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: "ГУ \"Комитет казначейства Министерства финансов РК\"",
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: "ГУ \"Комитет казначейства Министерства финансов РК\""
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100 shrink-0 translate-y-1"
                        })
                      ],
                      className: "flex lg:px-2 py-1 hover:bg-gray-pale items-start gap-1 group rounded-md w-fit justify-between lg:justify-start"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-start"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "БИК",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: "KKMFKZ2A",
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: "KKMFKZ2A"
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100"
                        })
                      ],
                      className: "flex lg:px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit justify-between lg:justify-start"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "ИИК",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: "KZ24070105KSN0000000",
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: "KZ24070105KSN0000000"
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100"
                        })
                      ],
                      className: "flex lg:px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit justify-between lg:justify-start"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Кбе",
                    className: "paragraph-small text-gray-light-landing lg:px-2 py-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                          children: "11",
                          className: "paragraph text-black-landing"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                            text: "11"
                          }),
                          className: "lg:opacity-0 group-hover:opacity-100"
                        })
                      ],
                      className: "flex lg:px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit justify-between lg:justify-start"
                    })
                  })
                ],
                className: "grid grid-cols-[56px_auto] lg:contents gap-2 items-center"
              })
            ],
            className: "lg:grid grid-cols-[auto_auto] gap-x-6 gap-y-1 items-center"
          })
        ],
        className: "mt-4 lg:mt-6 lg:flex lg:gap-20 items-start"
      })
    ]
  });
}

const make = ClassifiersKogdView;

export {
  make,
}
/* Buhta_components__CopyButton Not a pure module */
